var Option = function Option() {
  return null;
};

export default Option;